<script module>
  import Content from "./Content.svelte";
  import * as systemBanner from "@sourcewhale/shared/svelte-design-system/components/atoms/SystemBanner/utils.svelte";

  let licenseTitles = $state([]);

  const showTeamOverLicenseLimitBanner = (titles) => {
    licenseTitles = titles;
    systemBanner.addNotification({
      props: { kind: "error", leadingIcon: "fas fa-exclamation" },
      content,
    });
  };
  export { showTeamOverLicenseLimitBanner };
</script>

{#snippet content()}
  <Content {licenseTitles} />
{/snippet}
